//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Gateway.js";
import "../no/Builder.js";
let d=[[[0,"SaveName",1,0]],[[["orderList","saveName"],"Save",{},2,0],[["pastePoint","selectedEntries","currentOrder"],"Paste",{R_:{newOrder:""}},3,0],[["selectedEntries","currentOrder","numOfRemainingEntries"],"Delete",{R_:{newOrder:""}},3,0],[[],"Clear",{},0,0],[["selectedEntries","currentOrder"],"DownArrow",{R_:{newOrder:""}},2,0],[["selectedEntries","currentOrder"],"UpArrow",{R_:{newOrder:""}},2,0],[["savedOrderName","saveFileName","overwriteFile"],"SaveAsTextFile",{},3,0]],[]];
SPLM.Gateway.BaseExplicitOrderBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Gateway.BaseExplicitOrderBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;